// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Zxs8","title":"styles_title__rkUg8"};